<h1>Versionierung in video2manual</h1>
<section class="article">
  <article>
    <div class="text">
      <p>
        Mit der Version 2.2 bekommt video2manual die Funktion, Projekte mit
        Versionsnummern zu versehen. Dieser Beitrag zeigt, wie die
        Versionsnummern manuell oder automatisch vergeben und wozu sie genutzt
        werden können.
      </p>
      <h2>Versionsformate</h2>
      <p>
        video2manual unterstützt die Versionierung einfach (Version 1, Version 2
        ...) und zweiteilig (Version 1.0, Version 1.1 …). Die Einstellung des
        Versionsformats kann in jedem Projekt einzeln vorgenommen werden. Im
        Dialog "Projekt bearbeiten" gibt es dazu einen neuen Reiter
        "Versionierung".
      </p>
      <img src="assets/versioning_project.png" style="width: 600px" />
      <p>
        Für alle neuen Projekte kann das Versionsformat auch in den Optionen
        voreingestellt werden.
      </p>
      <img src="assets/versioning_options.png" style="width: 600px" />
      <p>
        Das Versionsformat lässt sich jederzeit auch nachträglich im Projekt
        ändern.
      </p>
      <h2>Versionszählung</h2>
      <p>
        Im einfachsten Fall kann die Version manuell eingetragen werden. Je nach
        Versionsformat sind auch hier einfache oder zweiteilige Versionsnummern
        erlaubt.
      </p>
      <p>
        video2manual kann das Hochzählen der Versionsnummer aber auch
        automatisch übernehmen.
      </p>
      <img src="assets/versioning_automatic.png" style="width: 600px" />
      <p>
        Im gezeigten Beispiel wird der zweite Teil der Versionsnummer des
        Projekts vor jedem Speichern erhöht, d.h., die gespeicherte Version hat
        jeweils eine neue Versionsnummer (1.0, 1.1, 1.2 …). Der erste Teil der
        Versionsnummer wird immer vor dem Publizieren mit angewählter
        Archivierung erhöht (1.0, 2.0, 3.0 …). Diese Einstellung würde sich z.B.
        anbieten, wenn man auch zwischendurch für Testzwecke publiziert, aber
        immer erst am Ende einer Bearbeitung archiviert.
      </p>
      <h2>Verwendung der Versionsnummer</h2>
      <p>
        Die Versionsnummer wird immer aktuell in der v2m-Datei gespeichert und
        kann so zu Nachweiszwecken verwendet werden. Sie ist aber auch ein
        zusätzliches Meta-Datum und kann überall dort zum Einsatz kommen, wo
        Meta-Daten genutzt werden können.
      </p>
      <p>
        So kann die Versionsnummer z.B. in den Publikationspfad eingebaut
        werden.
      </p>
      <img src="assets/versioning_publication_path.png" style="width: 600px" />
      <p>
        Im Dialog zum Publizieren eines Utility Films kann auf dem Reiter
        "Pfad-Einstellungen" dazu das Feld "Version" genutzt werden.
      </p>
      <p>Beispiele (Projektversion ist 2.5):</p>
      <table
        style="
          text-align: left;
          margin-left: auto;
          margin-right: auto;
          border-style: ridge;
        "
      >
        <tr>
          <td>V[Version:#]</td>
          <td>V2</td>
        </tr>
        <tr>
          <td>V_[Version:#.#]</td>
          <td>V_2.5</td>
        </tr>
        <tr>
          <td>Version [Version:###.#]&nbsp;</td>
          <td>Version 002.5</td>
        </tr>
      </table>
      <p>
        Die gleichen Einstellungen sind für den Pfad der Archivdatei möglich.
      </p>
      <p>
        Auch in den Zwischentiteln der Archivdatei kann die Versionsnummer
        eingeblendet werden.
      </p>
      <img src="assets/versioning_intertitle.png" style="width: 600px" />
    </div>
  </article>
</section>
